<template>
    <div id="message">
        <p id="letter" :class="hasChar('lowercaseLetter') ? 'valid' : 'invalid'">
            {{ Lang.get('component/password-validation.requirements.lowercase') }}</p>
        <p id="capital" :class="hasChar('upperCaseLetters') ? 'valid' : 'invalid'">
            {{ Lang.get('component/password-validation.requirements.uppercase') }}</p>
        <p id="number" :class="hasChar('numbers') ? 'valid' : 'invalid'">
            {{ Lang.get('component/password-validation.requirements.number') }}</p>
        <p id="character" :class="hasChar('specialCharacter') ? 'valid' : 'invalid'">
            {{ Lang.get('component/password-validation.requirements.special') }}</p>
        <p id="length" :class="hasLength(10) ? 'valid' : 'invalid'">
            {{ Lang.get('component/password-validation.requirements.amount') }}</p>
    </div>
</template>
<script>

export default {
    name: "PasswordValidation",
    props: {
        inputVal: {
            required: true,
            type: null, String,
        }
    },
    methods: {
        hasChar: function (type) {
            const characterTypes = {
                'lowerCaseLetter': /[a-z]/g,
                'upperCaseLetters': /[A-Z]/g,
                'numbers': /[0-9]/g,
                'specialCharacter': /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/
            };

            if (this.inputVal) {
                return this.inputVal.match(characterTypes[type]);
            }
            return false;
        },

        hasLength(length) {
            if (this.inputVal) {
                return this.inputVal.length >= length;
            }
            return false;
        },

    }
}

</script>

